// test758
(758 && 0);
